import React, {useEffect, useState, useRef } from "react";
import "./gridControls.scss";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

const OverflowComponent = ({onClick, items, intl = null}) => {
    const containerRef = useRef(null);
    const [visibleItems, setVisibleItems] = useState(items);

    useEffect(() => {
        const handleResize = () => {
            if(containerRef.current) {
                const conatinerWidth = containerRef.current.offsetWidth;
                const itemsPerRow = Math.floor(conatinerWidth /80);
                setVisibleItems(items.slice(0, itemsPerRow-1))
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () =>{
            window.removeEventListener('resize', handleResize);
        }
    }, [items])

    return <div ref={containerRef} onClick={onClick}>
        {visibleItems.map((item, index) => (<span className="multi-value-label" key={index}>{injectIntlTranslation(intl, item, item)}</span>))}
        {items.length > visibleItems.length && <span className="multi-value-label">+{items.length - visibleItems.length}</span>}
    </div>
}

export default injectIntl(OverflowComponent);